import React, { Component } from 'react'
import T from 'i18n-react'
import CSSModules from 'react-css-modules'
import { branch, renderNothing } from 'recompose'

import { hideSpecItem, getCurStatus, } from 'helpers/specHelpers'
import SpecItem from 'components/custom/SpecItem/index'

import styles from './styles.scss'

class ListItemSpec extends Component {
  renderItems(initValues, modifiedValues) {
    const {
      moduleName,
      isModifiedPage,
      risks,
      curFilter,
    } = this.props

    return initValues.map((initValue, index) => {
      const modifiedValue = modifiedValues[index]
      const risk = risks ? risks[index] === 'Risk' : false
      const curStatus = getCurStatus(risk, initValue, modifiedValue)
      if (hideSpecItem(isModifiedPage, modifiedValue, initValue, risk, curFilter))
        return

      return (
        <SpecItem
          key={index}
          label={`${T.translate(`project.spec.${moduleName}.item`)}${index + 1}`}
          initValue={initValue ? initValue : ''}
          modifiedValue={modifiedValues[index]}
          isModifiedPage={isModifiedPage}
          risk={risk}
          curFilter={curFilter}
          curStatus={curStatus}
        />
      )
    })
    // filter null values
    .filter(val => val)
  }

  render() {
    const {
      moduleData,
      showTopBorder,
      ModuleHeader,
    } = this.props
    let {
      initValues,
      modifiedValues,
    } = moduleData

    if (!initValues) initValues = []
    if (!modifiedValues) modifiedValues = []

    const initLen = initValues.length
    const modifiedLen = modifiedValues.length

    if (initLen < modifiedLen) {
      initValues = initValues.concat(Array(modifiedLen - initLen).fill(null))
    } else {
      modifiedValues = modifiedValues.concat(Array(initLen - modifiedLen).fill(null))
    }

    const items = this.renderItems(initValues, modifiedValues)
    const Header = ModuleHeader ? branch(
      () => items.length <= 0,
      renderNothing
    )(ModuleHeader) : null
    return (
      <div>
        { Header ? <Header /> : null }
        <div styleName={ showTopBorder ? 'specItemListItem' : '' }>
          { items }
        </div>
      </div>
    )
  }
}

export default CSSModules(ListItemSpec, styles)
